import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2OnModule } from 'angulartics2';

import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { IntegrationsComponent } from './integrations.component';
import { WebhooksComponent } from './components/webhooks/webhooks.component';
import { AddEditWebhookComponent } from './modals';
import { ApiComponent } from './components/api/api.component';
import { SquareComponent } from './components/square/square.component';
import { IntegrationsRoutingModule } from './integrations.routing.module';
import { ReserveWithGoogleComponent } from './components/reserve-with-google/reserve-with-google.component';
import { StripeComponent } from './components/stripe/stripe.component';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    FrontendIconsModule,
    IntegrationsRoutingModule,
    RouterModule,
    FrontendDropdownModule,
    Angulartics2OnModule,
    FrontendModalModule,
    FrontendPullRefreshModule,
  ],
  declarations: [
    IntegrationsComponent,
    WebhooksComponent,
    AddEditWebhookComponent,
    ApiComponent,
    SquareComponent,
    ReserveWithGoogleComponent,
    StripeComponent,
  ],
})
export class IntegrationsModule {
}
